import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActionSheetController, App, NavController, NavParams, LoadingController } from 'ionic-angular';
import { SharingProvider } from '../../../providers/sharing/sharing';
import { PublicProfileModel, UserProvider } from '../../../providers/user/user';
import { BackgroundModel } from '../../../providers/value/value';
import { MysportContactsPage } from '../../me/mysport/mysport-contacts/mysport-contacts';
import { ResultProvider } from '../../../providers/result/result';
import { SocialSharing } from '@ionic-native/social-sharing';

/**
 * Generated class for the ResoultProfilePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-result-profile',
  templateUrl: 'result-profile.html'
})
export class ResultProfilePage {
  profile: PublicProfileModel;
  profileTabs: string;
  backgrounds: BackgroundModel[];
  result = null;
  friendExist: boolean = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public app: App,
    public translate: TranslateService,
    private shareService: SharingProvider,
    private sharer: SocialSharing,
    public actionSheetCtrl: ActionSheetController,
    private userService: UserProvider,
    private loadingCtrl: LoadingController,
    private resultService: ResultProvider
  ) {
    this.profile = navParams.get('profile');
    console.log('prifile',this.profile)
    this.backgrounds = navParams.get('backgrounds');
    this.result = navParams.get('result');
    this.profileTabs = 'results';
    this.userService.friendExist(this.profile.id).then((result) => this.friendExist = result);
    console.log('this.result: ', this.result);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ResoultProfilePage');
  }

  showActionSheet() {
    let actionSheet = this.actionSheetCtrl.create({
      title: this.translate.instant('GLOBAL_OPTIONS'),
      buttons: [
        {
          text: this.translate.instant('PUBLICPROFILE_DASBINICH'),
          role: 'dasbinich',
          handler: () => {
            // this.userService.thatsMe(this.profile.id);
          }
        },
        {
          text: this.translate.instant('GLOBAL_CANCEL'),
          role: 'cancel'
        }
      ]
    });

    actionSheet.present();
  }

  addFriend() {
    this.userService.addFriend(this.profile.id).then(friendList => {
      // var loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
      // loader.present();
      // this.userService.getMyFans().then(fanList => {
      // (this.app.getRootNav() as NavController).push(MysportContactsPage, { friendList: friendList }).then(() => loader.dismiss());
      // });
      this.friendExist = true;
    });
  }

  removeFriend() {
    this.userService.removeFriend(this.profile.id).then(() => {
      this.friendExist = false;
    });
  }


  getProfileBg() {
    let themeImage = 'wood.jpg';

    if (typeof this.profile.themeName !== 'undefined' && this.profile.themeName !== '') {
      themeImage = this.backgrounds.find(x => x.value === this.profile.themeName).img;
    }
    return themeImage;
  }

  getHeaderShade() {
    let themeShade = 'dark';

    if (typeof this.profile.themeName !== 'undefined' && this.profile.themeName !== '') {
      themeShade = this.backgrounds.find(x => x.value === this.profile.themeName).shade;
    }

    return themeShade;
  }

  share() {
    this.sharer.shareViaFacebook('', null, "https://spooorts.de/ui/showTrophyPublicMe.jsf?mo=pub&id=" + this.profile.id + '&current=' + new Date().getTime());

  }
}



// WEBPACK FOOTER //
// /src/pages/results/result-profile/result-profile.ts